// Issue classification badge with icon and confidence indicator
import { Badge } from '@/components/ui/badge'
import { Settings, User, Bug, Zap, Database, Link, HelpCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface IssueClassificationBadgeProps {
  category?: string
  className?: string
}

const CATEGORY_CONFIG: Record<string, {
  label: string
  icon: typeof Bug
  color: string
}> = {
  configuration: {
    label: 'Configuration Issue',
    icon: Settings,
    color: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  bug: {
    label: 'Software Bug',
    icon: Bug,
    color: 'bg-red-100 text-red-800 border-red-200',
  },
  feature_request: {
    label: 'Feature Request',
    icon: Zap,
    color: 'bg-purple-100 text-purple-800 border-purple-200',
  },
  performance: {
    label: 'Performance Issue',
    icon: Zap,
    color: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  data: {
    label: 'Data Issue',
    icon: Database,
    color: 'bg-amber-100 text-amber-800 border-amber-200',
  },
  integration: {
    label: 'Integration Issue',
    icon: Link,
    color: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  },
  user_error: {
    label: 'User Guidance',
    icon: User,
    color: 'bg-green-100 text-green-800 border-green-200',
  },
  other: {
    label: 'Other',
    icon: HelpCircle,
    color: 'bg-gray-100 text-gray-800 border-gray-200',
  },
}

export function IssueClassificationBadge({
  category,
  className,
}: IssueClassificationBadgeProps): JSX.Element | null {
  if (!category) return null

  const config = CATEGORY_CONFIG[category] || CATEGORY_CONFIG.other
  const Icon = config.icon

  return (
    <Badge variant="outline" className={cn('gap-1.5 px-3 py-1 text-sm font-medium', config.color, className)}>
      <Icon className="h-3.5 w-3.5" />
      {config.label}
    </Badge>
  )
}
